import {Observable} from 'rxjs';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {AppDialogRef} from './app-dialog-ref';
import {DrawerEntry} from './app-drawer.types';

export class AppDrawerDynamicDialogRef {
	readonly onClose: Observable<unknown>;

	constructor(private readonly appRef: AppDialogRef) {
		this.onClose = this.appRef.onClose;
	}

	close(result?: unknown): void {
		this.appRef.close(result);
	}

	destroy(): void {
		// Cycle de vie géré par le host drawer.
	}
}

export function buildDrawerDynamicDialogConfig(entry: DrawerEntry): DynamicDialogConfig {
	const spreadContext =
		typeof entry.context === 'object' && entry.context !== null && !Array.isArray(entry.context)
			? {...(entry.context as Record<string, unknown>)}
			: {};

	return {
		data: {
			...spreadContext,
			__appDialogRef: entry.ref,
		},
		header: entry.header,
		closable: entry.closable,
		closeOnEscape: entry.closeOnEscape,
		showHeader: entry.showHeader,
	};
}
